export default __webpack_public_path__ + "static/media/magnet.c1632789.jpg";